module.exports = __webpack_public_path__ + "static/ParulHariharan.388e160b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/ParulHariharan.jpg
// module id = 244
// module chunks = 25111403944408 251948199435738